import { render, staticRenderFns } from "./ModuleInfoPlaceholder.vue?vue&type=template&id=128eee9d"
import script from "./ModuleInfoPlaceholder.vue?vue&type=script&lang=js"
export * from "./ModuleInfoPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports